package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.doc.Shadow
import dev.lingvo.shared.screenshots.geom.lengthScale

/** Canvas ignores its transform for shadows, so convert every length to device pixels first. */
fun resolveShadow(shadow: Shadow, transform: Affine, palette: Palette, slotIndex: Int): DeviceShadow {
    val scale = transform.lengthScale()
    return DeviceShadow(shadow.dx * scale, shadow.dy * scale, shadow.blur * scale, resolveColor(shadow.color, palette, slotIndex))
}
